
import { connect } from 'react-redux';
import { assign as _assign } from 'lodash';
import {
  ResetPasswordModel,
  CreateFormProps,
  GlobalState,
  formatMessage
} from 'src/api';

import {
  createForm
} from 'src/api/models/Form/Form';

import {
  resetPasswordFormValues
} from 'src/api/models/ResetPassword/reset-password.class';

import { 
  requestAPIActions, 
  RequestApiHttpPayload, 
} from 'loopback-react-request';
import MESSAGES from './ResetPasswordForm.messages';
import './ResetPasswordForm.scss';

const ResetPasswordFormProperty = createForm<ResetPasswordModel, CreateFormProps<ResetPasswordModel>>({
  className: 'partial-login-form my-0 mx-auto',
  dispatchData: (dispatch, values) => 
    dispatch(requestAPIActions.load<RequestApiHttpPayload>('resetPassword', {
      url: '/Users/request-password-reset',
      options: {
        method: 'POST',
        data: values,
      },
    })
  ),
  formFields: resetPasswordFormValues(),
  redirectTo: '/reset-password/succeeded',
  shouldRedirect: true,
  stateKeys: 'resetPassword',
  submitButton: {
    text: formatMessage({...MESSAGES.resetPasswordFormButton}),
    className: 'register-button mt-3 w-100'
  }
})();

export const ResetPasswordForm = connect((state: GlobalState) => ({state}))(ResetPasswordFormProperty);
